import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'
import { getFirstAccessibleAdminPath } from '../lib/dashboardNav'

export default function AdminIndexRedirect() {
  const { canAccessPage } = useAuth()
  const path = getFirstAccessibleAdminPath(canAccessPage)
  if (path) {
    return <Navigate to={path} replace />
  }
  return <Navigate to="/" replace />
}
